<template lang="html">
  <div class="pb-5">
    <b-field>
      <template slot="label">
        Tags
        <b-tooltip
          position="is-right"
          type="is-dark"
          multilined
          size="is-small"
          label="List of tags which qualifies the creation, helps for searchability."
        >
          <b-icon type="is-gray" size="is-small" icon="help-circle-outline"></b-icon>
        </b-tooltip>
      </template>

      <b-taginput
        v-model="localTags"
        ellipsis
        icon="label"
        maxlength="200"
        maxtags="30"
        :confirm-keys="[',', 'Tab', 'Enter', ' ']"
        :placeholder="placeholder"
        @input="updateTags"
      />
    </b-field>
  </div>
</template>

<script>
export default {
  props: ['tags', 'placeholder', 'label'],
  data () {
    return {
      localTags: []
    }
  },
  created () {
    this.localTags = this.tags
  },
  methods: {
    updateTags (value) {
      this.$emit('updateTags', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
